import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnInit, } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiSettingForm } from '@components/ui-forms/ui-setting-form';
import { BehaviorSubject } from 'rxjs';
import { delay, takeUntil, } from 'rxjs/operators';
var ScalabilityControl;
(function (ScalabilityControl) {
    ScalabilityControl["signalR"] = "signalR";
    ScalabilityControl["signalRConfig"] = "signalRConfig";
})(ScalabilityControl || (ScalabilityControl = {}));
var ScalabilitySignalRControl;
(function (ScalabilitySignalRControl) {
    ScalabilitySignalRControl["webSocketTransport"] = "webSocketTransport";
    ScalabilitySignalRControl["serverSentEventsTransport"] = "serverSentEventsTransport";
    ScalabilitySignalRControl["longPollingTransport"] = "longPollingTransport";
})(ScalabilitySignalRControl || (ScalabilitySignalRControl = {}));
var UiScalabilityComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UiScalabilityComponent, _super);
    function UiScalabilityComponent(_fb, cd, appState) {
        var _this = _super.call(this, cd, appState) || this;
        _this._fb = _fb;
        _this.ScalabilityControl = ScalabilityControl;
        _this.ScalabilitySignalRControl = ScalabilitySignalRControl;
        _this._formValueToPayload = function (formValue) { return ({
            signalR: {
                enabled: formValue.signalR,
                transportProtocol: {
                    webSocketTransport: formValue.signalRConfig.webSocketTransport,
                    serverSentEventsTransport: formValue.signalRConfig.serverSentEventsTransport,
                    longPollingTransport: formValue.signalRConfig.longPollingTransport,
                },
            },
        }); };
        _this._transportOptionsValidator = function (form) {
            if (form.get(ScalabilitySignalRControl.webSocketTransport).value ||
                form.get(ScalabilitySignalRControl.serverSentEventsTransport).value ||
                form.get(ScalabilitySignalRControl.longPollingTransport).value) {
                return null;
            }
            return {
                invalidSelection: true,
            };
        };
        return _this;
    }
    UiScalabilityComponent.prototype.ngOnInit = function () {
        var _a, _b;
        var _this = this;
        this.signalRChange$ = new BehaviorSubject(this.settings.scalability.signalR.enabled);
        this.formGroup = this._fb.group((_a = {},
            _a[ScalabilityControl.signalR] = [
                this.settings.scalability.signalR.enabled,
            ],
            _a));
        var signalRSettingsFormGroup = this._fb.group((_b = {},
            _b[ScalabilitySignalRControl.webSocketTransport] = [
                this.settings.scalability.signalR.transportProtocol.webSocketTransport,
            ],
            _b[ScalabilitySignalRControl.serverSentEventsTransport] = [
                this.settings.scalability.signalR.transportProtocol.serverSentEventsTransport,
            ],
            _b[ScalabilitySignalRControl.longPollingTransport] = [
                this.settings.scalability.signalR.transportProtocol.longPollingTransport,
            ],
            _b));
        this.formGroup.addControl(ScalabilityControl.signalRConfig, signalRSettingsFormGroup);
        this.signalRChange$
            .pipe(delay(0), takeUntil(this._destroyed$))
            .subscribe(function (enabled) {
            var signalRConfigFormGroup = _this.formGroup.get(ScalabilityControl.signalRConfig);
            if (enabled) {
                signalRConfigFormGroup.enable();
                signalRConfigFormGroup.setValidators(_this._transportOptionsValidator);
                signalRConfigFormGroup.updateValueAndValidity();
            }
            else {
                signalRConfigFormGroup.disable();
                signalRConfigFormGroup.setValidators(null);
            }
        });
        this.formGroup.valueChanges
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function () {
            Object.assign(_this.settings.scalability, _this._formValueToPayload(_this.formGroup.getRawValue()));
        });
        this.isReadOnly$
            .pipe(delay(0), takeUntil(this._destroyed$))
            .subscribe(function (isReadOnly) {
            if (isReadOnly) {
                _this.formGroup.disable();
            }
            else {
                _this.formGroup.enable();
                // needed to disable the signalR transport settings if the case
                _this.signalRChange$.next(_this.signalRChange$.getValue());
            }
        });
    };
    UiScalabilityComponent.prototype.onSignalRToggle = function (event) {
        this.signalRChange$.next(event.checked);
    };
    return UiScalabilityComponent;
}(UiSettingForm));
export { UiScalabilityComponent };
